const Icon = ({
  name,
  className,
  ...props
}: { name: string; className?: string } & Record<string, any>): JSX.Element => {
  return (
    <span className={`material-icons ${className || ""}`} {...props}>
      {name?.replace(/-/g, "_")}
    </span>
  );
};

export default Icon;
